import { render, staticRenderFns } from "./TBK_renewal.vue?vue&type=template&id=7c3234dd&"
import script from "./TBK_renewal.vue?vue&type=script&lang=js&"
export * from "./TBK_renewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports